import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { getFormattedPrice, ReceiptSubtotal } from "@qgiv/core-donor";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";

const ConnectedReceiptSubtotal = ({
    total,
    originalTotal = 0,
    subtotalLabel = "",
}) => {
    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { registrationFeeDisplay, registrationFeeDisplayText } = p2pSettings;

    const hasPromo = originalTotal > total;
    const receiptSubtotalProps = {
        hasPromo,
        subtotalLabel,
        originalTotal: currencyString(originalTotal, currency),
        total: getFormattedPrice(
            total,
            currency,
            registrationFeeDisplay,
            registrationFeeDisplayText,
        ),
    };

    return <ReceiptSubtotal {...receiptSubtotalProps} />;
};

ConnectedReceiptSubtotal.propTypes = {
    total: PropTypes.number.isRequired,
    originalTotal: PropTypes.number,
    subtotalLabel: PropTypes.string,
};

export default ConnectedReceiptSubtotal;
